<template>
  <div class="account-settings">
    <h1 class="h3 mb-4">Notification Preferences</h1>
    <b-card>
      <b-form>
        <b-form-checkbox
          id="form-input-notifications-promotions"
          class="mb-2"
          v-model="notifications.promotions"
          name="Promotions"
          size="md"
          switch>
          General promotions, updates, and news
        </b-form-checkbox>
        <b-form-checkbox
          id="form-input-notifications-listings"
          class="mb-2"
          v-model="notifications.listings"
          name="Listings"
          size="md"
          switch>
          Updates about listings, including approval confirmations and purchase requests
        </b-form-checkbox>
        <b-form-checkbox
          id="form-input-notifications-receipts"
          class="mb-2"
          v-model="notifications.receipts"
          name="Receipts"
          size="md"
          switch
          disabled>
          Receipts for any payments you make on ZoopLocal. <em>(Required)</em>
        </b-form-checkbox>
        <b-form-checkbox
          id="form-input-notifications-policies"
          class="mb-2"
          v-model="notifications.account"
          name="Account"
          size="md"
          switch
          disabled>
          Important account updates,
          including updates to our policies
          and password reset emails <em>(Required)</em>
        </b-form-checkbox>
      </b-form>
      <template
        v-slot:footer>
        <div class="text-right">
          <b-button
            variant="primary"
            squared>
            Update Preferences
          </b-button>
        </div>
      </template>
    </b-card>
  </div>
</template>

<script>
export default {
  name: 'AccountSettings',
  data() {
    return {
      notifications: {
        promotions: true,
        listings: true,
        account: true,
        receipts: true,
      },
    }
  },
}
</script>
